// A free-field date of "0" represents an empty date.
export const isFreeFieldDateEmpty = (value: string): boolean => !value || value === "0";
